<template>
  <div id="Case">
    <div id="Case-top"></div>
    <div id="Case-body">
      <p class="Case-title">上海市教委</p>
      <p class="Case-content">上海市幼儿园早期儿童健康项目的评估检查</p>
      <div class="Case-content-div">
        <div class="Case-content-left">
          <img src="../../assets/images/Solution/Case/TheNeedSofTheShanghaiMunicipalEducationCommittee.png"/>
          <p>上海<span style="color:#74b6ec;">16</span>个区县抽样<span style="color:#74b6ec;">200</span>多个幼儿园<br>入学儿童进行早期健康的评估</p>
        </div>
        <div class="Case-content-middle">
          <p>有效样本率接近<span style="color:#74b6ec;">99%</span><br>有效数据接近<span style="color:#74b6ec;">100%</span></p>
        </div>
        <div class="Case-content-right">
          <img src="../../assets/images/Solution/Case/TheResultsOfTheShanghaiMunicipalEducationCommittee.png"/>
          <p>有效完成抽样人群</p>
          <p><span style="color:#74b6ec;">20000</span>多个儿童的早期健康评估</p>
        </div>
      </div>
      <p class="Case-title" style="margin-top:120px;">上海体育学院/教育部</p>
      <p class="Case-content">全国儿童青少年体育健身指数</p>
      <div class="Case-content-div">
        <div class="Case-content-left" style="margin-right:8px;">
          <img src="../../assets/images/Solution/Case/Statistics.png"/>
          <p>全国32个省+新疆兵团小初高的抽样人群<br>进行问卷调查抽样人数(包含家长)<span style="color:#74b6ec;">约30万</span></p>
        </div>
        <div class="Case-content-middle">
          <p style="margin-top:18px;">有效样本率接近<span style="color:#74b6ec;">90%</span></p>
        </div>
        <div class="Case-content-right" style="margin-left:18px;">
          <img src="../../assets/images/Solution/Case/questionnaire.png"/>
          <p>网络电子问卷完成样本有效数据接近<span style="color:#74b6ec;">100%</span><br>纸质问卷回收有效样本率接近<span style="color:#74b6ec;">80%</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#Case-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/Solution/Case/Case_Banner.png);
}
#Case-body{
  padding-top: 60px;
  padding-bottom: 60PX;
}
#Case-body .Case-title{
  font-size: 36px;
  color: #282828;
  margin-bottom: 10px;
}
#Case-body .Case-content{
  font-size: 18px;
  color: #909090;
  margin-bottom: 40px;
}
#Case-body .Case-content-div{
  width: 1080px;
  height: 154px;
  background-repeat:no-repeat;
  background-position:center 20px ;
  background-image: url(../../assets/images/Solution/Case/arrow.png);
  display: inline-block;
}
#Case-body .Case-content-div p{
  line-height: 22px;
}
#Case-body .Case-content-div .Case-content-left{
  display: inline-block;
  vertical-align: top;
  margin-right: 40px;
}
#Case-body .Case-content-div .Case-content-middle{
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
#Case-body .Case-content-div .Case-content-right{
  margin-left: 54px;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/pages/Solution/Case.vue